import React from "react";
import { ChevronDownIcon } from "@heroicons/react/24/outline";

function SupportContent() {
  return (
    <div className="w-full px-2 py-3 pb-24 overflow-y-auto">
      <div className="mx-6 my-2">
        <div className="font-bold text-2xl text-start">
          Add your support content for Fin AI Agent
        </div>
        <p className="text-sm text-gray-700 pt-1 text-start">
          How to add content Fin AI Agent can use to start providing customers
          with answers.
        </p>
        <div className="pt-5 flex items-center gap-3">
          <img
            className="w-10 h-10 border-2 border-white rounded-full"
            src="https://upload.wikimedia.org/wikipedia/commons/thumb/4/49/Elon_Musk_2015.jpg/408px-Elon_Musk_2015.jpg"
            alt=""
          />
          <div className="flex flex-col text-sm text-gray-700 text-start">
            <div>Written by Anish Dhakal</div>
            <div>Updated over a month ago</div>
          </div>
        </div>
        <div className="font-normal text-base mt-6">
          <button className="flex justify-between items-center w-full px-3 py-2 border rounded-lg shadow">
            <span>Table of contents</span>
            <ChevronDownIcon className="h-4 w-4" strokeWidth={2} />
          </button>
        </div>
        <p className="mt-6 text-start text-sm">
          Fin AI Agent is hungry for information. The more you feed it, the
          better it performs. Fin AI Agent can use your Intercom public articles
          and snippets, as well as external support content, so you can decide
          exactly which sources of information you would like Fin to use when
          answering customers' questions.
        </p>
        <p className="mt-6 text-start text-sm">
          Fin AI Agent will automatically generate responses called AI answers
          by using the support content you add. You'll be able to preview this
          before going live.
        </p>
        <div className="mt-6 border rounded-2xl bg-slate-200 p-5 text-sm text-start">
          See our Best Practices for optimizing your support content for Fin.
        </div>
      </div>
    </div>
  );
}

export default SupportContent;
